import React, { Component } from "react";
import AntdAlert, {AlertProps} from 'antd/lib/alert';
import 'antd/lib/alert/style';

export default class Alert extends Component<AlertProps> {
    render() {
        const { message, ...restProps } = this.props;
        return (
          <AntdAlert message={message} {...restProps} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/alert/index.tsx